var map = {
	"./AzureOpenAIAPIBotSettings.vue": 32669,
	"./BardBotSettings.vue": 55538,
	"./BingChatBotSettings.vue": 10402,
	"./CharacterAIBotSettings.vue": 28778,
	"./ChatGPTBotSettings.vue": 39762,
	"./ClaudeAIBotSettings.vue": 94647,
	"./GradioAppBotSettings.vue": 35928,
	"./HuggingChatBotSettings.vue": 44531,
	"./LMSYSBotSettings.vue": 78797,
	"./LoginSetting.vue": 35562,
	"./MOSSBotSettings.vue": 54899,
	"./OpenAIAPIBotSettings.vue": 57272,
	"./OpenAssistantBotSettings.vue": 38570,
	"./PiBotSettings.vue": 25947,
	"./PoeBotSettings.vue": 55982,
	"./QianWenBotSettings.vue": 44575,
	"./Qihoo360AIBrainBotSettings.vue": 74467,
	"./SkyWorkBotSettings.vue": 31927,
	"./SparkBotSettings.vue": 61043,
	"./WenxinQianfanBotSettings.vue": 31736,
	"./YouChatBotSettings.vue": 71633
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 66912;
module.exports = webpackAsyncContext;